import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import Modal from '@/components/Modal';
import { t } from '@/services/translations/config';
import { COLOR, ENTITY_COLOR } from '@/theme/colors';

import { Props } from './types';

const SuccessInvitationSentModal: React.FC<Props> = ({
    onCancel,
    onConfirm,
    isLoading,
}) => {
    return (
        <Modal isOpen center styles="pt-11 pb-7 px-9 min-w-[760px]">
            <Box className="flex flex-col">
                <Typography
                    fontSize={16}
                    fontWeight={700}
                    color={COLOR.ebonyClay}
                    className="mb-4"
                >
                    {t('Organisation:cancel_invitation_title')}
                </Typography>
                <Typography
                    fontSize={14}
                    fontWeight={300}
                    color={COLOR.ebonyClay}
                >
                    {t('Organisation:cancel_invitation_description')}
                </Typography>

                <Box className="flex gap-[4px] justify-end mt-4">
                    <Button
                        className="px-[8px] self-end"
                        variant="text"
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: COLOR.tundora,
                            '&:hover': {
                                backgroundColor: COLOR.white,
                            },
                        }}
                        onClick={onCancel}
                    >
                        {t('Actions:cancel')}
                    </Button>

                    <Button
                        className="px-[20px] py-[10px] self-end"
                        variant="contained"
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: COLOR.white,
                            backgroundColor: ENTITY_COLOR.teams,
                            '&:hover': {
                                backgroundColor: ENTITY_COLOR.teams,
                            },
                        }}
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 700,
                                color: COLOR.white,
                            }}
                        >
                            {t('Actions:confirm')}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SuccessInvitationSentModal;
